import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cv-templetes',

  templateUrl: './cv-templetes.component.html',
  styleUrls: ['./cv-templetes.component.css'],
})
export class CvTempletesComponent {
  @Input() formGroup!: FormGroup;

  cvTempletes = [
    {
      image: './assets/img/cv-templetes/current-cv.png',
      name: 'cvTemplate',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete2.png',
      name: 'cvTemplate2',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete3.png',
      name: 'cvTemplate3',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete4.png',
      name: 'cvTemplate4',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete5.png',
      name: 'cvTemplate5',
      isActive: true,
    },
    {
      image: './assets/img/cv-templetes/templete7.png',
      name: 'cvTemplate6',
      isActive: true,
    },
    { image: './assets/img/cv-templetes/2.png', isActive: false },
    { image: './assets/img/cv-templetes/1.png', isActive: false },
    { image: './assets/img/cv-templetes/3.png', isActive: false },
    { image: './assets/img/cv-templetes/4.png', isActive: false },
    { image: './assets/img/cv-templetes/5.png', isActive: false },
    { image: './assets/img/cv-templetes/6.png', isActive: false },
    { image: './assets/img/cv-templetes/7.png', isActive: false },
    { image: './assets/img/cv-templetes/8.png', isActive: false },
    { image: './assets/img/cv-templetes/9.png', isActive: false },
    { image: './assets/img/cv-templetes/10.png', isActive: false },
    { image: './assets/img/cv-templetes/11.png', isActive: false },
    { image: './assets/img/cv-templetes/12.png', isActive: false },
  ];

  selectedName!: string;
  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  ngOnInit() {
    if (this.formGroup) {
      this.selectedName = this.formGroup.get('cvTempleteFile')?.value;
    }
    console.log(this.selectedName);
  }
  selectCv(name: string) {
    this.selectedName = name;

    this.formGroup.get('cvTempleteFile')?.setValue(name);
  }
  onNext() {
    this.next.emit();
  }
  onPrevious() {
    this.previous.emit();
  }
}
